import React, {Component, PropTypes} from 'react'
import api from '../../apiClient/v2'
import * as css from '../management-oc/ManagementOC.css'
import {TableServices} from './DataTable.jsx'

export class BillingServices extends Component{
    constructor(props){
        super(props)
        this.state = {
            services: [],
            totalNeto: 0,
            iva: 0,
            total: 0,
            month: this.props.monthsDate[0]['value'],
            idClient: 5
        }
        this.fetchServices = () => {
            api.billing().getServicesByMonthAndClient(this.state.idClient, this.state.month)
                .then(response => {
                    this.setState({
                        services: response.services,
                        totalNeto: response.total_neto,
                        iva: response.iva,
                        total: response.total
                    })
                })
                .catch(err=>{})
        }
        this.onChangeMonth = (evt) => {
            this.setState({
                month: evt.target.value
            }, () => this.fetchServices())
        }
        this.onChangeClient = (evt) => {
            this.setState({
                idClient: evt.target.value
            }, () => this.fetchServices())
        }
    }
    componentDidMount(){
        this.fetchServices()
    }
    render(){
        return(
            <div className="container-fluid">
                <div className={`page-header row ${css.headerManagementOC}`}>
                    <div className="col-md-9">
                        <h3><span className='glyphicon glyphicon-th-list'></span> Servicios grupo Salcobrand</h3>
                    </div>
                    <div className={`col-md-3 ${css.divExcelButton}`}>
                        <a className="btn btn-success btn-md pull-right"
                           disabled="true">
                            {'Exportar '}
                            <span className="glyphicon glyphicon-export"/>
                        </a>
                    </div>
                </div>
                <SelectClient
                    idClient={this.state.idClient}
                    onChangeClient={this.onChangeClient}
                />
                <SelectMonth
                    month={this.state.month}
                    onChangeMonth={this.onChangeMonth}
                    monthsDate={this.props.monthsDate}
                />
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-primary">
                            <div className="panel-heading">Servicios realizados</div>
                            <TableServices
                                services={this.state.services}
                                totalNeto={this.state.totalNeto}
                                iva={this.state.iva}
                                total={this.state.total}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
BillingServices.propTypes = {
    monthsDate: PropTypes.arrayOf(PropTypes.object).isRequired
}
const SelectMonth = ({month, onChangeMonth, monthsDate}) => {
    return (
        <div className="col-sm-2 form-group">
            <label className="control-label">Mes</label>
            <select className="form-control"
                    value={month}
                    onChange={onChangeMonth}>
                >
                {monthsDate.map((month, index)=>{
                    return <option key={index} value={month['value']}>{`${month['text']}`}</option>
                })}
            </select>
        </div>
    )
}

const SelectClient = ({idClient, onChangeClient}) => {
    return (
        <div className="col-sm-2 form-group">
            <label className="control-label">Cliente</label>
            <select className="form-control" 
                value={idClient}
                onChange={onChangeClient}>
            >
                <option key={1} value={1}>PUC</option>
                <option key={5} value={5}>FSB</option>
            </select>
        </div>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/billing/billing-services/BillingServices.jsx